import * as $ from "jquery";

export default class PublishReportComponent {
    constructor() {
        this.componentSelector = ".publish-report";
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('.js-report').off().on('click', function () {
            instance.run(instance);
        });
    }

    run(instance) {
        let sku = $('#sku').val();

        axios({
            method: 'get',
            url: "/report/publishstatus",
            data: { sku: sku }
        }).then(function (response) {
            console.log(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }
}